import React, {useEffect, useState} from "react";
import {useDropzone} from "react-dropzone";
import CloseIcon from '@mui/icons-material/Close';

// STYLE
import "./style.css";
import axios from "axios";
import http, {getDomain} from "../../api/http";

const thumbsContainer = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    padding: '10px',
    width: '100%',
    border: '1px dashed #eee'
};


const inputStyle = {
    display: "block",
    width: "100%",
    border: "1px solid #eaeaea",

};

const thumb = {
    display: "block",
    borderRadius: 2,
    border: "1px solid #eaeaea",
    width: 162,
    height: 162,
    padding: 4,
    position: "relative",
    boxSizing: "border-box"
};

const thumbInner = {
    display: "flex",
    minWidth: 0,
    overflow: "hidden",
    maxHeight: '100%',
    maxWidth: '100%',

};

const img = {
    display: "block",
    width: "auto",
    height: "100%",
};

const buildImageSrc = (domain, fileUrl) => {
    if (!fileUrl) return '';
    if (/^https?:\/\//i.test(fileUrl)) return fileUrl;
    const normalizedPath = fileUrl.startsWith('/') ? fileUrl : `/${fileUrl}`;
    return `${domain}${normalizedPath}`;
};

const getFileMeta = (file) => {
    if (!file) return { url: '', name: '' };
    const nested = file.file || {};
    const url = file.url || nested.url || '';
    const name = file.originalName || file.name || nested.originalName || nested.name || '';
    return { url, name };
};

function Dropzone(props) {
    const [cd, setCd] = useState(new Date().getTime())
    const domain = getDomain();
    const files = props.files;
    let {getRootProps, getInputProps, open} = useDropzone({
        accept: "image/*",
        onDrop: (acceptedFiles) => {
            console.log("qqqqq acceptedFiles", acceptedFiles);
            uploadToServer(acceptedFiles, (file) => {
                let _files = [file]
                props.onChange && props.onChange(_files)
            })
        }
    });


    const uploadToServer = (_files, cb) => {
        let file = (_files || files)[0];
        const formData = new FormData();
        formData.append("file", file);
        console.log("qqqqq form data send", formData);

        http.post("/api/media/upload", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
            .then(response => {
                return response.data;

            })
            .then(data => {
                console.log("File uploaded successfully:", data);
                cb && cb(data)
            })
            .catch(error => {
                console.error("Error uploading file:", error);
            });
    }

    const removeFile = (ind) => () => {
        console.log("qqqqq removeFile", ind);
        const newFiles = [...files];
        newFiles.splice(ind, 1);
        console.log("qqqqq new Files", newFiles);
        props.onChange && props.onChange(newFiles)
    };

    // const thumbs = ;

    useEffect(
        () => () => {
            // Make sure to revoke the data uris to avoid memory leaks
            files.forEach((file) => URL.revokeObjectURL(file.preview));
        },
        [files]
    );
    let file = (files || {})[0]
    const fileMeta = file ? getFileMeta(file) : null
    const imageSrc = fileMeta ? buildImageSrc(domain, fileMeta.url) : ''

    let isEditor = (global)?.isEditor;

    if (!isEditor) {
        open = () => {}
    }
    console.log("qqqqq Drop Zone", props.files, files, file);
    return (
        <section className="container dropzone-container" data-fade onClick={open}>
            <div
                style={{display: "none", zIndex: 10000, opacity: 0, height: 0, overflow: "hidden"}}
                {...getRootProps({className: "dropzone"})}
                onClick={open}
            >
                <input {...getInputProps()} style={{opacity: 0}}/>
                <p style={{opacity: 0}}>Click to load files</p>
            </div>
            <>

                <aside>
                    {/* {(files || []).map((file, ind) => { */}
                    {/* return */}
                    {fileMeta && imageSrc && (
                        <div style={thumb} key={`${fileMeta.url || fileMeta.name || 'file-preview'}`} data-img-hover>
                            <div style={thumbInner}>
                                <img src={imageSrc} style={img} alt={fileMeta.name || 'uploaded-file'}/>
                            </div>
                            <div data-img-hover-wrap>
                                <ImgIcons
                                    onDelete={() => {
                                        props.onChange && props.onChange([])
                                    }}
                                    onChange={open}
                                ></ImgIcons>
                            </div>
                        </div>
                    )}
                    {/* })} */}

                    {isEditor && !file && <div style={{...thumb, textAlign: 'center', cursor: 'pointer'}}>
                        <UploadImgText></UploadImgText>
                    </div>}


                </aside>
            </>


        </section>
    );
}

export const ImgIcons = (props) => {
    let isEditor = (global)?.isEditor;

    if (!isEditor) {
        return null;
    }
    return <div className={'imgWrapCont'}>
        <div onClick={(e) => {
            props.onChange && props.onChange()
            e.preventDefault && e.preventDefault()
            e.stopPropagation && e.stopPropagation();
            return null;
        }} data-hover2>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <mask id="mask0_688_6271" style={{"maskType": "alpha"}} maskUnits="userSpaceOnUse" x="3" y="2"
                      width="20"
                      height="19">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M16.0151 4.67422C15.7222 4.96711 15.7222 5.44198 16.0151 5.73488C16.308 6.02777 16.7828 6.02777 17.0757 5.73488L18.25 4.56066V8.75C18.25 9.16421 18.5857 9.5 19 9.5C19.4142 9.5 19.75 9.16421 19.75 8.75V4.56066L20.9242 5.73488C21.2171 6.02777 21.6919 6.02777 21.9848 5.73488C22.2777 5.44198 22.2777 4.96711 21.9848 4.67422L19.5303 2.21967C19.2374 1.92678 18.7625 1.92678 18.4696 2.21967L16.0151 4.67422ZM5.75 4.5C5.05964 4.5 4.5 5.05964 4.5 5.75V13.1893L7.18125 10.5081L7.18365 10.5057C7.32273 10.3651 7.48824 10.2534 7.67067 10.177C7.85416 10.1002 8.05109 10.0606 8.25 10.0606C8.44891 10.0606 8.64584 10.1002 8.82933 10.177C9.01176 10.2534 9.17727 10.3651 9.31635 10.5057L13.496 14.6853L13.496 14.6853L13.5 14.6893L13.504 14.6853L15.4336 12.7557C15.5727 12.6151 15.7382 12.5034 15.9207 12.427C16.1042 12.3502 16.3011 12.3106 16.5 12.3106C16.6989 12.3106 16.8958 12.3502 17.0793 12.427C17.2618 12.5034 17.4273 12.6151 17.5664 12.7557L19.5 14.6893V12C19.5 11.5858 19.8358 11.25 20.25 11.25C20.6642 11.25 21 11.5858 21 12V16.5V18.25C21 19.7688 19.7688 21 18.25 21H5.75C4.23122 21 3 19.7688 3 18.25V15V5.75C3 4.23122 4.23122 3 5.75 3H12C12.4142 3 12.75 3.33579 12.75 3.75C12.75 4.16421 12.4142 4.5 12 4.5H5.75ZM4.5 18.25V15.3106L8.24596 11.5647L8.25002 11.5606L8.25403 11.5647L8.25404 11.5647L12.4336 15.7442C12.5727 15.8848 12.7382 15.9966 12.9207 16.073C13.1042 16.1498 13.3011 16.1894 13.5 16.1894C13.6989 16.1894 13.8958 16.1498 14.0793 16.073C14.2618 15.9966 14.4273 15.8848 14.5664 15.7442L16.496 13.8147L16.5 13.8106L16.504 13.8147L16.504 13.8147L19.5 16.8106V18.25C19.5 18.9404 18.9404 19.5 18.25 19.5H5.75C5.05964 19.5 4.5 18.9404 4.5 18.25Z"
                          fill="black"/>
                </mask>
                <g mask="url(#mask0_688_6271)">
                    <path d="M24 0H0V24H24V0Z" fill="white"/>
                </g>
            </svg>
            <div>
                Change Image
            </div>
        </div>
        <div style={{opacity: .7}} onClick={(e) => {
            props.onDelete && props.onDelete()
            e.preventDefault && e.preventDefault()
            e.stopPropagation && e.stopPropagation();
            return null;
        }} data-hover2>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <mask id="mask0_688_6296" style={{"maskType": "alpha"}} maskUnits="userSpaceOnUse" x="3" y="2"
                      width="18" height="20">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M9.75 2C9.15326 2 8.58097 2.23705 8.15901 2.65901C7.73705 3.08097 7.5 3.65326 7.5 4.25V5H5.25H4.5H3.75C3.33579 5 3 5.33579 3 5.75C3 6.16421 3.33579 6.5 3.75 6.5H4.5V18.75C4.5 20.2688 5.73122 21.5 7.25 21.5H16.75C18.2688 21.5 19.5 20.2688 19.5 18.75V6.5H20.25C20.6642 6.5 21 6.16421 21 5.75C21 5.33579 20.6642 5 20.25 5H19.5H18.75H16.5V4.25C16.5 3.65326 16.2629 3.08097 15.841 2.65901C15.419 2.23705 14.8467 2 14.25 2H9.75ZM15 5V4.25C15 4.05109 14.921 3.86032 14.7803 3.71967C14.6397 3.57902 14.4489 3.5 14.25 3.5H9.75C9.55109 3.5 9.36032 3.57902 9.21967 3.71967C9.07902 3.86032 9 4.05109 9 4.25V5H15ZM8.25 6.5H6V18.75C6 19.4404 6.55964 20 7.25 20H16.75C17.4404 20 18 19.4404 18 18.75V6.5H15.75H8.25ZM10.5 10.25C10.5 9.83579 10.1642 9.5 9.75 9.5C9.33579 9.5 9 9.83579 9 10.25V16.25C9 16.6642 9.33579 17 9.75 17C10.1642 17 10.5 16.6642 10.5 16.25V10.25ZM13.5 10.25C13.5 9.83579 13.8358 9.5 14.25 9.5C14.6642 9.5 15 9.83579 15 10.25V16.25C15 16.6642 14.6642 17 14.25 17C13.8358 17 13.5 16.6642 13.5 16.25V10.25Z"
                          fill="black"/>
                </mask>
                <g mask="url(#mask0_688_6296)">
                    <path d="M24 0H0V24H24V0Z" fill="white"/>
                </g>
            </svg>
            <div >
                Delete Image
            </div>
        </div>
    </div>
}
export const UploadImgText = () => {
    return <>
        <svg
            style={{marginTop: '35px'}}
            xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <mask id="mask0_629_6265" style={{"maskType": "alpha"}} maskUnits="userSpaceOnUse" x="4" y="4" width="28"
                  height="28">
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M4.75 7.625C4.75 6.03718 6.03718 4.75 7.625 4.75H28.375C29.9628 4.75 31.25 6.03718 31.25 7.625V28.375C31.25 29.9628 29.9628 31.25 28.375 31.25H7.625C6.03718 31.25 4.75 29.9628 4.75 28.375V7.625ZM7.625 6.5C7.00368 6.5 6.5 7.00368 6.5 7.625V20.3875L10.95 15.9376L10.9527 15.9348C11.1383 15.7471 11.3591 15.598 11.6026 15.4961C11.8472 15.3937 12.1098 15.3409 12.375 15.3409C12.6402 15.3409 12.9028 15.3937 13.1474 15.4961C13.3909 15.598 13.6117 15.7471 13.7973 15.9348L13.8 15.9376L20.0672 22.2047L20.0672 22.2047L20.0719 22.2094C20.0951 22.2331 20.1229 22.2518 20.1534 22.2646C20.184 22.2774 20.2169 22.284 20.25 22.284C20.2831 22.284 20.316 22.2774 20.3466 22.2646C20.3771 22.2518 20.4049 22.2331 20.4281 22.2094L20.4281 22.2094L20.4328 22.2047L23.3277 19.3098C23.5132 19.1222 23.7341 18.973 23.9776 18.8711C24.2222 18.7687 24.4848 18.7159 24.75 18.7159C25.0152 18.7159 25.2778 18.7687 25.5224 18.8711C25.7659 18.973 25.9868 19.1222 26.1723 19.3098L29.5 22.6375V7.625C29.5 7.00368 28.9963 6.5 28.375 6.5H7.625ZM6.5 28.375V22.8624L12.1922 17.1702L12.1969 17.1655L12.1969 17.1655C12.2201 17.1419 12.2479 17.1231 12.2784 17.1103C12.309 17.0975 12.3418 17.0909 12.375 17.0909C12.4082 17.0909 12.441 17.0975 12.4716 17.1103C12.5021 17.1231 12.5299 17.1419 12.5531 17.1655L12.5578 17.1703L12.5578 17.1702L18.825 23.4374L18.8277 23.4401C19.0132 23.6278 19.2341 23.7769 19.4776 23.8788C19.7222 23.9813 19.9848 24.034 20.25 24.034C20.5152 24.034 20.7778 23.9813 21.0224 23.8788C21.2659 23.7769 21.4868 23.6278 21.6723 23.4401L24.5672 20.5452L24.5719 20.5405L24.5719 20.5405C24.5951 20.5169 24.6229 20.4981 24.6534 20.4853C24.684 20.4725 24.7169 20.4659 24.75 20.4659C24.7831 20.4659 24.816 20.4725 24.8466 20.4853C24.8771 20.4981 24.9049 20.5169 24.9281 20.5405L24.9328 20.5453L24.9328 20.5452L29.5 25.1124V28.375C29.5 28.9963 28.9963 29.5 28.375 29.5H7.625C7.00368 29.5 6.5 28.9963 6.5 28.375ZM21.75 12.9375C21.75 13.8695 20.9945 14.625 20.0625 14.625C19.1305 14.625 18.375 13.8695 18.375 12.9375C18.375 12.0055 19.1305 11.25 20.0625 11.25C20.9945 11.25 21.75 12.0055 21.75 12.9375Z"
                      fill="black"/>
            </mask>
            <g mask="url(#mask0_629_6265)">
                <path d="M36 0H0V36H36V0Z" fill="#808080"/>
            </g>
        </svg>
        <b data-hover2 data-center className={'uploadText'}>
            Upload Image
        </b>
    </>
}
export default Dropzone;
